import EndPointConfig from '../../models/api/EndPointConfig'

const controller = 'Companies'

export const CompaniesEP : EndPointConfig[] =[
        new EndPointConfig()
        .setMethod("GET")
        .setController(controller)
        .setActionName("GetCompanies")
]